"use client";

import Image from "next/image";

import RiveAnimation, { Fit } from "@/components/global/RiveAnimation";
import { cn } from "@/lib/utils";

interface TradersMosaicProps {
  variant?: "home" | "community";
  label?: string;
  className?: string;
}

const rows = [
  [
    ["01", "opacity-20"],
    ["02", "opacity-40"],
    ["03", "opacity-80"],
    ["04", "opacity-80"],
    ["05", "opacity-80"],
    ["06", "opacity-40"],
    ["07", "opacity-20"],
  ],
  [
    ["08", "opacity-20"],
    ["09", "opacity-40"],
    ["10", "opacity-80"],
    [null, "opacity-0"],
    [null, "opacity-0"],
    ["13", "opacity-80"],
    ["14", "opacity-40"],
    ["15", "opacity-100"],
  ],
  [
    ["16", "opacity-20"],
    ["17", "opacity-40"],
    ["18", "opacity-80"],
    ["19", "opacity-80"],
    ["20", "opacity-80"],
    ["21", "opacity-40"],
    ["22", "opacity-20"],
  ],
] as const;

export default function TradersMosaic({
  variant = "home",
  label = "1500 traders",
  className,
}: TradersMosaicProps) {
  if (variant === "home") {
    return (
      <RiveAnimation
        src="/home/wce_asset_people.riv"
        stateMachine="State Machine 1"
        fit={Fit.Cover}
        className={className}
      />
    );
  }

  const normalizedLabel = label.replace(/^\+/, "");

  return (
    <div
      className={cn(
        "relative h-[29.5rem] overflow-hidden rounded-[1rem] bg-[#0a171f] lg:h-[42.375rem]",
        className,
      )}
    >
      <div className="absolute top-[3.0033rem] left-[-1.5rem] h-[24.3298rem] w-[48.25rem] overflow-hidden lg:top-[2.625rem] lg:h-[37.125rem] lg:w-[73.625rem]">
        <div className="absolute top-[0.5734rem] left-[-9.1749rem] flex w-[66.5649rem] flex-col items-center gap-[0.9181rem] lg:top-[0.875rem] lg:left-[-14rem] lg:w-[101.5718rem] lg:gap-[1.401rem]">
          {rows.map((row, rowIndex) => (
            <div
              key={rowIndex}
              className={cn(
                "flex shrink-0 items-center justify-center gap-[0.9181rem] lg:gap-[1.401rem]",
                rowIndex === 1 && "w-full",
              )}
            >
              {row.map(([image, opacity], imageIndex) => (
                <div
                  key={image ?? `empty-${imageIndex}`}
                  className={cn(
                    "relative h-[7.1155rem] w-[7.1155rem] shrink-0 overflow-hidden rounded-full lg:h-[10.8576rem] lg:w-[10.8576rem]",
                    opacity,
                  )}
                >
                  {image && (
                    <Image
                      src={`/community/events/traders-mosaic/community-trader-${image}.png`}
                      alt=""
                      width={174}
                      height={174}
                      sizes="(min-width: 1024px) 87px, 57px"
                      className="absolute inset-0 h-full w-full object-cover"
                    />
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>

        <div className="absolute top-[9.6664rem] left-[16.5475rem] flex h-[5.079rem] w-[15.1549rem] items-center justify-center rounded-[8.1919rem] bg-white lg:top-[14.75rem] lg:left-[25.25rem] lg:h-[7.75rem] lg:w-[23.125rem]">
          <span className="font-geist text-[1.966rem] leading-none font-medium text-black lg:text-[3rem]">
            <span className="text-[#606060]">+</span>
            {normalizedLabel}
          </span>
        </div>
      </div>
    </div>
  );
}
